export default __webpack_public_path__ + "static/medmun-1031eda4d0e35ea671889fdef71b6967.png";